<template>
  <Header>
    <template v-slot:title>お問い合わせ</template>
    <template v-slot:subtitle>Contact</template>
    <template v-slot:leadtext>
      御葬儀についてのご心配、ご不安
      <br />
      事前のご相談もお気軽にご連絡ください
      <br />
      24時間、365日ご対応しております。
    </template>
    <template v-slot:text>
      お急ぎのご連絡だけでなく、事前のご相談や、葬儀についてご不明な点や不安な点などございましたら、お気軽にご連絡ください。
    </template>
  </Header>
  <section id="contents">
    <div class="contact-grid">
      <div class="item" v-for="(item, i) in $halllist" :key="i">
        <div class="imgwrap">
          <img
            :src="require('../assets/images/thumb-' + item.id + '.jpg')"
            :alt="item.name"
          />
        </div>
        <div class="tx">
          <h3>
            <img src="@/assets/images/logo01.svg" alt="天聖閣" />
            {{ item.name }}
          </h3>
          <p class="address">{{ item.zip }} {{ item.address }}</p>
          <a class="tel" :href="item.tel">
            <img
              :src="require('../assets/images/tel-' + item.id + '.svg')"
              :alt="item.tel"
            />
          </a>
          <router-link class="detail" :to="'/information/' + item.id">
            詳細をみる
          </router-link>
        </div>
      </div>
    </div>
  </section>
  <Footer></Footer>
</template>
<script>
import Header from "@/components/PartsPageHeader.vue";
import Footer from "@/components/PartsFooter.vue";
export default {
  components: {
    Header,
    Footer,
  },
  setup() {},
};
</script>
<style lang="scss" scoped>
#contents {
  width: 100%;
  padding: 0 1rem;
  margin: 0 auto;
  .contact-grid {
    max-width: $maxwidth;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: clamp(16px, 5vw, 80px);
    margin: 0 auto;
    @include tb {
      grid-template-columns: 1fr;
    }
    .item {
      background-color: white;
      display: grid;
      grid-template-columns: 1fr;
      grid-gap: 0;
      .imgwrap {
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          @include tb {
            aspect-ratio: 21/9;
          }
        }
      }
      .tx {
        padding: 1rem;
        h3 {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          font-size: 1.5rem;
          width: 100%;
          margin-bottom: 1rem;

          img {
            width: auto;
            height: 2.5rem;
            flex-grow: 0;
            margin-right: 1rem;
          }
        }
        .address {
          text-align: center;
          margin-bottom: 1rem;
          @include tb {
            font-size: 0.875rem;
          }
        }
        .tel {
          display: block;
          text-align: center;
          color: $blue;
          font-size: 1.25rem;
          height: 2rem;
          margin-bottom: 1rem;
          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
        .detail {
          display: block;
          text-align: center;
          color: $blue;
          border: 1px solid $blue;
          font-size: 1.25rem;
          padding: 0.5em 1em;
        }
      }
    }
  }
}
</style>
